module.exports = __webpack_public_path__ + "static/img/order_msg_icon.478f9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/order_msg_icon.png
// module id = 3YY0
// module chunks = 0